export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: false,
  isRTL: false,
  isDark: false,
  isTopNav: false,
  isVertical: true,
  get isCombo() {
    return this.isVertical && this.isTopNav;
  },
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false,
  navbarStyle: 'transparent',
  ticketPriceToPay: 0.0,
  isDebug: (process.env.REACT_APP_IS_DEBUG==="true"),
  defaultDebuggingEnabled: false,
  anonymousUsername: "anonymous@crowdcatcher.co"
};

export const version = '3.135.2';
export const urls = {
  resourcesRoot: process.env.REACT_APP_RESOURCES_ROOT,
  account: process.env.REACT_APP_CROWDACCOUNT_URL,
  legal: process.env.REACT_APP_CROWDLEGAL_URL,
  eventcore: process.env.REACT_APP_CROWDEVENTCORE_URL,
  finance: process.env.REACT_APP_CROWDFINANCE_URL,
  content: process.env.REACT_APP_CROWDCONTENT_URL,
  reporting: process.env.REACT_APP_CROWDREPORTING_URL,
  comms: process.env.REACT_APP_CROWDCOMMS_URL,
  assist: process.env.REACT_APP_CROWDASSIST_URL,
  print: process.env.REACT_APP_CROWDPRINT_URL,
  integration: process.env.REACT_APP_CROWDINTEGRATION_URL,
  root: process.env.REACT_APP_ROOT_URL,
};

export const appleWalletLogo = process.env.REACT_APP_APPLE_WALLET_LOGO;

export const googleWalletLogo = process.env.REACT_APP_GOOGLE_WALLET_LOGO;

export const googleAPIKey = process.env.REACT_APP_GOOGLE_API_KEY;

export const defaultWebPage = process.env.REACT_APP_DEFAULT_WEB_PAGE;

export const badgeDesignerRootUrl = process.env.REACT_APP_BADGE_DESIGNER_ROOT_URL;

export const EntryFormMode = {
  EDIT: "EDIT",
  CREATE: "CREATE"
};

export const AccessMode = {
  USER: "USER",
  ADMIN: "ADMIN"
};

export const AttendeeMode = {
  SINGLE: "SINGLE",
  MULTI: "MULTI"
};

export const TransferRecipientType = {
  SMS: 1,
  EMAIL: 2
};

export const CheckinMode = {
  SELF_SERVICE: 1,
  ADMIN: 2
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings, urls };
